import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { TimeRecordItem } from 'store/api/timeRecords';
import { EffortListItem } from 'types/efforts';
import { TimecardListItemData } from 'types/timecards';
import { useClassifiers } from 'utils/useClassifiers';
import TimeRecordDayCard from './TimeRecordDayCard';

type Props = {
    items: TimeRecordItem[];
};

export type DayBucket = {
    timecards: TimecardListItemData[];
    efforts: EffortListItem[];
};

export const groupByDate = (items: TimeRecordItem[]): Map<string, DayBucket> => {
    const buckets = new Map<string, DayBucket>();
    items.forEach((item) => {
        let bucket = buckets.get(item.date);
        if (!bucket) {
            bucket = { timecards: [], efforts: [] };
            buckets.set(item.date, bucket);
        }
        if (item.kind === 'BD_EFFORT') {
            bucket.efforts.push(item.effort);
        } else {
            bucket.timecards.push(item.timecard);
        }
    });
    return buckets;
};

const TimeRecordList: FC<Props> = ({ items }) => {
    const { classifiers } = useClassifiers({ codes: ['TIMECARD_STATUS_TYPE'] });

    if (items.length === 0) {
        return (
            <div className="m-3.5 flex justify-center">
                <p className="text-body1">
                    <FormattedMessage id="dashboard.no-time-records-found" />
                </p>
            </div>
        );
    }

    const buckets = groupByDate(items);

    return (
        <div className="flex h-full flex-col">
            {Array.from(buckets).map(([date, bucket]) => (
                <TimeRecordDayCard
                    key={date}
                    date={date}
                    timecards={bucket.timecards}
                    efforts={bucket.efforts}
                    classifier={classifiers['TIMECARD_STATUS_TYPE']}
                    classifiers={classifiers}
                />
            ))}
        </div>
    );
};

export default TimeRecordList;
